import { isLgwanAccess, isProd } from '@/shared/lib/system';

// CloudFront のオリジンルーティングが `/support-site/*`（末尾スラッシュ込み）でしか
// サポートサイトバケットへ振り分けないため、ルート URL を開く場合は末尾スラッシュ必須。
const LGWAN_SUPPORT_SITE_BASE_URL = 'https://dnr.bns.kpn1.asp.lgwan.jp/support-site/';
const DEV_SUPPORT_SITE_BASE_URL = 'https://bookish-adventure-l121z23.pages.github.io/support-site/';
const PROD_SUPPORT_SITE_BASE_URL = 'https://support.dnr.wise-vine.com/';

/**
 * サポートサイトのベース URL を返す（末尾スラッシュあり）。
 * - LGWAN 経由のアクセス時はランタイムで LGWAN 用の URL を返す
 * - prod 環境では本番 URL を返す
 * - それ以外（dev / stg / ローカル）は GitHub Pages の dev 用 URL を返す
 *
 * サブパスを連結する場合は `${getSupportSiteBaseUrl()}news/xxx` のように
 * 先頭スラッシュなしで結合すること（二重スラッシュ回避）。
 */
export const getSupportSiteBaseUrl = () => {
  if (isLgwanAccess()) return LGWAN_SUPPORT_SITE_BASE_URL;
  if (!isProd()) return DEV_SUPPORT_SITE_BASE_URL;
  return PROD_SUPPORT_SITE_BASE_URL;
};
